import { POST } from '@/api'
import { format } from 'date-fns'
import { pickBy, some } from 'lodash'
import { padZero } from '@/utils/number'

export default {
  namespaced: true,
  state: {
    list: null,
    originDays: {},
    days: {},
    busy: false,
  },
  mutations: {
    set(state, data) {
      state.list = data.businessdayList
      Object.keys(data.businessdayList).forEach(month =>
        data.businessdayList[month].forEach(day => {
          state.originDays[`${month}-${padZero(day)}`] = true
        }),
      )
      state.days = { ...state.originDays }
    },
    updateStatus(state, statuses) {
      state.days = { ...state.days, ...statuses }
    },
    resetStatus(state) {
      state.days = { ...state.originDays }
    },
    updateOrigindays(state) {
      state.originDays = { ...state.days }
    },
    busy(state, busy) {
      state.busy = busy
    },
  },
  getters: {
    isChanged: state => some(state.days, (bool, day) => !!state.originDays[day] !== !!bool),
  },
  actions: {
    async get({ commit, state }, endDate = null) {
      if (state.busy) return false
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/businessday/list', {
        start_date: format(new Date(), 'YYYYMM'),
        end_date: endDate && format(endDate, 'YYYYMM'),
      })

      if (status === 200) {
        commit('set', data)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
    async saveBusinessdays({ commit, state }) {
      if (state.busy) return false
      commit('busy', true)

      const { status, message } = await POST('/api/web/businessday/regist', {
        businessday_list: pickBy(state.days, (bool, day) => !!state.originDays[day] !== !!bool),
      })
      if (status === 200) {
        commit('updateOrigindays')
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
